import {
  AxiosAction,
  isSuccessActionOf
} from '../middleware/axios';
import { isAction } from '../utils';

import {
  Check,
  EntitySnapshotForCheck
} from './state';

type CheckVersion = Check['id']['version'] | 'latest';

// Action Types

const GET_CHECK_VERSION = 'CHECK.GET';

// Action Interfaces

export interface GetCheckVersion extends AxiosAction<Check> {
  /** The check details which were fetched. */
  check: {
    id: Check['id']['entityId'];
    version: CheckVersion;
  };
  type: typeof GET_CHECK_VERSION;
}

// Action Creators

/** Fetches a single check model's data, for the version specified. */
export function getCheckVersion(
  check: Check['id']['entityId'],
  version: CheckVersion
): GetCheckVersion {
  return {
    check: { id: check, version },
    payload: {
      client: 'backend',
      request: {
        method: 'GET',
        url: `/checks/${check}/${version}`
      }
    },
    type: GET_CHECK_VERSION
  };
}
export const isGetCheckVersion = isAction<GetCheckVersion>(GET_CHECK_VERSION);
export const isGetCheckVersionSuccess = isSuccessActionOf<GetCheckVersion>(GET_CHECK_VERSION);
/** Fetches a single check model's data, for the check corresponding to the given entity snapshot. */
export function getCheckForSnapshot(snapshot: EntitySnapshotForCheck): GetCheckVersion {
  return getCheckVersion(snapshot.id, snapshot.version);
}
